var API_URL = "";
API_URL = "https://maintenanceportal.datavtech.com/";
API_URL = "https://mclean.pocketv.app/";
API_URL = location.href.split("#")[0];
export default API_URL;
